import { render, staticRenderFns } from "./CardSizeInstruction.vue?vue&type=template&id=4a04cfee"
import script from "./CardSizeInstruction.vue?vue&type=script&lang=js"
export * from "./CardSizeInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports